import type { TimeZone } from "@eroad/types";

const NZ_TIMEZONES: TimeZone[] = [
  { cities: ["Waitangi"], timeZone: "Pacific/Chatham" },
  {
    cities:
      "Auckland_Christchurch_Dunedin_Hamilton_Napier-Hastings_Nelson_Palmerston North_Rotorua_Tauranga_Wellington".split(
        "_",
      ),
    timeZone: "Pacific/Auckland",
  },
];

export { NZ_TIMEZONES };
